const cells = document.querySelector('.simple-slideshow-carousel').querySelectorAll('.carousel-cell');
cells.forEach(cell => {
  cell.style.visibility = 'visible';
  cell.style.display = 'block';
  cell.style.opacity = '1';
});

/* simple-slideshow script section */
$('.simple-slideshow-carousel').flickity({
    cellAlign: 'center',
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 3000,
    draggable: false,
    freeScroll: true,
    contain: true,
    lazyLoad: false,
    fullscreen: true,
    groupCells: 2,
    initialIndex: 0,
    imagesLoaded: true,
    accessibility: false,
    pauseAutoPlayOnHover: false,
    });